module.exports = __webpack_public_path__ + "d55627264a626a72165e27033bc60fd4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/meta_2023_chart.png
// module id = 1695
// module chunks = 0